import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { AccountRegisterListItem } from '../models/account-register-results.model';
import { AccountsFilterOption } from '../models/accounts-filter-option';

const area = 'Account Register';
export const accountRegisterAdapterActions = createRegisterActions<AccountRegisterListItem>(area);

export const createAccount = createAction('[Account Register] Create Account');

export const accountRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: AccountsFilterOption[] }>()
);

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);
